import {
  DateRange,
  dateRangesOverlap,
  firstDayOfWeek,
  getDayOfMonth,
  getMonthName,
  getVisibleDate,
  weeksBetween,
} from '../../../common/src/date_string.ts';
import { IntervalSongList } from '../../../common/src/model.ts';

export function getWeeklyListName(week: DateRange, schoolTerms: IntervalSongList[], name?: string) {
  const term = getTermForDateRange(week, schoolTerms);
  if (!term) {
    return `Week of ${getMonthName(week.start)} ${getDayOfMonth(week.start)}`;
  }
  name = name ?? term?.name;
  const weekNumber = getTermWeekNumber(term, week);
  return `${name ? name + ' - ' : ''}Week ${weekNumber}`;
}

export function getTermWeekNumber(term: IntervalSongList, week: DateRange) {
  const firstSundayOfTerm = firstDayOfWeek(term.interval.start);
  return weeksBetween(firstSundayOfTerm, week.start) + 1;
}

export function getTermTitle(term: IntervalSongList) {
  return term.name ?? getVisibleDate(term.interval.start);
}

export function getTermForDateRange(
  dateRange: DateRange,
  schoolTerms: IntervalSongList[],
): IntervalSongList | undefined {
  // reverse the list because a week is considered part of the *following* term if it spans two terms
  return schoolTerms.toReversed().find(({ interval }) => dateRangesOverlap(interval, dateRange));
}
